<template>
  <div class="wrapper">
    <div class="w-full flex items-center justify-center">
      <div class="card flex flex-col bg-white rounded max-w-sm w-full">
        <div class="w-full flex justify-between items-center pb-8">
          <h3 class="nxp-section-title">
            Insira o idioma
          </h3>
          <div @click="closePage" class="closeBtn">
            <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
              <path
                d="M15.5187 4.83176C15.4416 4.75451 15.3501 4.69322 15.2493 4.6514C15.1484 4.60958 15.0404 4.58806 14.9312 4.58806C14.8221 4.58806 14.714 4.60958 14.6132 4.6514C14.5124 4.69322 14.4208 4.75451 14.3437 4.83176L10.2687 8.89843L6.19374 4.82343C6.11659 4.74628 6.025 4.68508 5.92419 4.64332C5.82339 4.60157 5.71535 4.58008 5.60624 4.58008C5.49713 4.58008 5.38909 4.60157 5.28829 4.64332C5.18748 4.68508 5.09589 4.74628 5.01874 4.82343C4.94159 4.90058 4.88039 4.99217 4.83864 5.09298C4.79688 5.19378 4.77539 5.30182 4.77539 5.41093C4.77539 5.52004 4.79688 5.62808 4.83864 5.72888C4.88039 5.82968 4.94159 5.92128 5.01874 5.99843L9.09374 10.0734L5.01874 14.1484C4.94159 14.2256 4.88039 14.3172 4.83864 14.418C4.79688 14.5188 4.77539 14.6268 4.77539 14.7359C4.77539 14.845 4.79688 14.9531 4.83864 15.0539C4.88039 15.1547 4.94159 15.2463 5.01874 15.3234C5.09589 15.4006 5.18748 15.4618 5.28829 15.5035C5.38909 15.5453 5.49713 15.5668 5.60624 15.5668C5.71535 15.5668 5.82339 15.5453 5.92419 15.5035C6.025 15.4618 6.11659 15.4006 6.19374 15.3234L10.2687 11.2484L14.3437 15.3234C14.4209 15.4006 14.5125 15.4618 14.6133 15.5035C14.7141 15.5453 14.8221 15.5668 14.9312 15.5668C15.0403 15.5668 15.1484 15.5453 15.2492 15.5035C15.35 15.4618 15.4416 15.4006 15.5187 15.3234C15.5959 15.2463 15.6571 15.1547 15.6988 15.0539C15.7406 14.9531 15.7621 14.845 15.7621 14.7359C15.7621 14.6268 15.7406 14.5188 15.6988 14.418C15.6571 14.3172 15.5959 14.2256 15.5187 14.1484L11.4437 10.0734L15.5187 5.99843C15.8354 5.68176 15.8354 5.14843 15.5187 4.83176Z"
                fill="#696969" />
            </svg>
          </div>
        </div>

        <div class="w-full flex flex-col space-y-4">
          <div class="w-full flex flex-col space-y-2">
            <label for="language" class="nxp-label">
              Idioma
            </label>
            <v-select id="language" :options="defaults_languages" :reduce="language => language.value"
              v-model="payload.language" />
          </div>

          <div class="w-full flex flex-col space-y-2">
            <label for="levels" class="nxp-label">
              Proficiência
            </label>
            <v-select id="levels" :options="levels" :reduce="level => level.value" v-model="payload.level" />
          </div>

        </div>

        <button class="nxp-continue-btn mt-12" :style="{ background: color }" type="button" @click="saveLanguage">
          Salvar
        </button>

      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { ModelSelect } from "vue-search-select";
import vSelect from "vue-select";

export default {
  components: {
    ModelSelect,
    "v-select": vSelect
  },
  props: ["language"],
  data: () => ({
    languages: [],
    payload: {
      index: 0,
      name: "",
      level: "",
      language: ""
    },
    levels: [
      { value: "Básico", label: "Básico" },
      { value: "Intermediário", label: "Intermediário" },
      { value: "Avançado", label: "Avançado" },
      { value: "Fluente", label: "Fluente" },
      { value: "Nativo", label: "Nativo" }
    ]
  }),
  computed: {
    ...mapState("language", ["defaults_languages"]),
    color() {
      return this.$store.state.company.company.base_hexcolor || "#1551b1";
    }
  },
  methods: {
    closePage() {
      this.$router.back();
    },
    onChange(e) {
      if (e.target.name == "language")
        this.language = e.target.value.length > 0 ? e.target.value : "";
      if (e.target.name == "nivel")
        this.nivel = e.target.value.length > 0 ? e.target.value : "";
    },
    fetchLanguages() {
      this.$vs.loading({ text: "Carregando..." });

      const label = sessionStorage.getItem("label");

      console.log('label', label)

      this.$http
        .get(`api/v1/talent/${label}/user/talent?step=languages`)
        .then(response => {
          this.$vs.loading.close();

          const { languages } = response.data.data;

          console.log("languages", languages)

          this.languages = languages;
        })
        .catch(() => {
          this.$vs.loading.close();
        });
    },

    async saveLanguage() {
      if (this.payload.level == "") {
        this.$vs.notify({
          color: "danger",
          title: "Falha ao salvar idioma",
          text: "Para salvar é necessário escolher uma proficiência!",
          position: "top-right"
        });
      }

      if (this.payload.language == "") {
        this.$vs.notify({
          color: "danger",
          title: "Falha ao salvar idioma",
          text: "Para salvar é necessário escolher um idioma!",
          position: "top-right"
        });
      }

      this.$vs.loading({ text: "Salvando..." });

      if (this.payload.language != "" && this.payload.level != "") {
        const name = this.payload.language.concat(` ${this.payload.level}`);

        this.payload = {
          ...this.payload,
          name
        };

        const { company_label } = this.$router.history.current.params;

        this.$http
          .post(`api/v1/talent/${company_label}/user/talent?step=languages`, {
            languages: [
              {
                ...this.payload
              }
            ]
          })
          .then(async response => {
            this.$vs.loading.close();

            this.payload = {
              ...this.payload,
              id: response.data.data.languages[0].id,
              index: response.data.data.languages[0].index
            };

            this.languages.push(this.payload);

            await this.$store.dispatch("language/store", {
              ...this.payload
            });
            
            // PostHog: language_added
            (async () => {
              try {
                const { trackEvent } = await import("@/services/posthog");
                trackEvent("language_added", {
                  language: this.payload.language || this.payload.name,
                  level: this.payload.level,
                });
              } catch (_) {}
            })();
            
            this.$router.back();
          })
          .catch(() => {
            this.$vs.loading.close();
          });
      }
    },

  },
  created() {
    window.scroll(0, 0);
    this.fetchLanguages();
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/talent/views/steps/step.scss";

.wrapper {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  width: 100%;
  padding: 16px;
  background: #fff;

  @media screen and (min-width: 768px) {
    padding: 36px;
  }
}

.closeBtn {
  display: flex;
  justify-content: flex-end;
}

.title {
  display: flex;
  justify-content: center;

  h1 {
    font-size: 20px;
  }
}

.content {
  padding: 16px 0;
  display: flex;
  justify-content: center;
}

.group {
  width: 100%;
  margin: 16px auto;

  @media only screen and (min-width: 1020px) {
    width: 70%;
  }
}

.button {
  width: 100%;
  display: flex;
  padding: 1rem;
  color: white;
  font-size: 1.25rem;
  border: 0;
  border-radius: 5px;
  justify-content: center;
  background-color: #1551b1;
}
</style>
